import HpglLogo from "../../assets/HPGL-logo.png";
import HpglLogoDark from "../../assets/Hpgl-logo-dark.png";
import ThemeSwitch from "../ThemeSwitch";
import { useNavigate } from "react-router-dom";

import { Bars3Icon, BellIcon } from "@heroicons/react/24/outline";
import { Heading } from "../catalyst/heading";

export const HeaderBar: React.FC<any> = ({ setSidebarOpen, currentSeason }) => {
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-3 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8 dark:bg-gray-900">
      <button
        data-testid="hamburger-open"
        type="button"
        className="-m-2.5 p-2.5 text-gray-700 lg:hidden dark:text-white"
        onClick={() => setSidebarOpen(true)}
      >
        <span className="sr-only">Open sidebar</span>
        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
      </button>
      <div className="flex shrink-0 items-center lg:hidden">
        <img alt="HPGL" src={HpglLogo} className="h-10 w-12 dark:hidden" />
        <img
          alt="HPGL"
          src={HpglLogoDark}
          className="h-10 w-12 hidden dark:block"
        />
        <Heading level={2} className="ml-5">
          HPGL
        </Heading>
      </div>
      {currentSeason &&
        currentSeason.sponsors &&
        currentSeason.sponsors.length > 0 && (
          <div className="flex items-center gap-x-2 ml-2">
            <a
              href={currentSeason.sponsors[0].link}
              target="_blank"
              rel="noreferrer"
            >
              <img
                alt={currentSeason.sponsors[0].name}
                className="hidden dark:block w-full object-contain max-h-[60px]"
                src={`/api/static/images/${currentSeason.sponsors[0].logoDark}`}
              />
              <img
                alt={currentSeason.sponsors[0].name}
                className="dark:hidden w-full object-contain max-h-[60px]"
                src={`/api/static/images/${currentSeason.sponsors[0].logo}`}
              />
            </a>
          </div>
        )}
      <div className="flex flex-1 justify-end gap-x-4 lg:gap-x-6">
        <div className="flex items-center gap-x-4 lg:gap-x-6">
          <button
            type="button"
            className="rounded-full p-1.5 text-gray-400 hover:text-gray-500 dark:text-gray-500 dark:hover:text-gray-400"
            onClick={() => navigate("/notifications")}
          >
            <span className="sr-only">Notifications</span>
            <BellIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <ThemeSwitch />
        </div>
      </div>
    </div>
  );
};
